<template>
    <button class="btn btn-info" title="Ausgenommene Urlaubstage diesen Monat / verfügbare Urlaubstage">
        {{leavesTaken}}/{{formattedTotalPossibleLeaves}}
    </button>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { calculateCarryOver } from '@/services/carryOverService';

export default {
    name: "userLeaves",
    props: ['user'],
    data() {
        return {
            leavesTaken: 0,
            totalPossibleLeaves: 0,
            leaveCounts: [],
            currentMonth: moment().month() + 1,
        };
    },
    created() {
        this.calculateLeavesCount(this.user);
        this.calculateTotalPossibleLeaves(this.user);
    },
    computed: {
        formattedTotalPossibleLeaves() {
            return this.totalPossibleLeaves > 0 ? `+${this.totalPossibleLeaves}` : this.totalPossibleLeaves;
        }
    },
    methods: {
        calculateLeavesCount: function (user) {
            axios({ method: "GET", url: process.env.VUE_APP_API_PATH+"Hours/GetAvailedLeavesCount?userId=" + user.id })
            .then(result => {
                this.leavesTaken = result.data;
            })
            .catch(error => {
                console.error(error);
                if (error.response && error.response.status === 401) {
                    this.$router.push("/");
                }
            });
        },
        calculateTotalPossibleLeaves: function (user) {
            const now = moment().format("yyyy-MM-DD");
            calculateCarryOver(user, now)
            .then(totalLeavesDifferencePrevYear => {
                this.totalPossibleLeaves = (totalLeavesDifferencePrevYear).toFixed(2);
            })
            .catch(error => {
                console.error(error);
            });
        },
    }
}
</script>
